import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { ArianeNavComponent } from 'src/app/layout/ariane-nav/ariane-nav.component';
import { MatDividerModule } from '@angular/material/divider';
import { DataTableOptimizedComponent } from 'src/app/shared/data-table-optimized/data-table-optimized.component';
import { ReferentielsService } from 'src/app/core/services/referentiels.service';
import { BehaviorSubject, debounceTime, distinctUntilChanged, map, Observable, Subject, take, takeUntil } from 'rxjs';
import { FilterGenerique } from '@models/api/requests';
import { PagedResultDTO } from '@models/shared';
import { MatIconModule } from '@angular/material/icon';
import { ExcelService } from 'src/app/core/services/excel.service';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ToastrDownloadService } from 'src/app/services/toastr-download.service';
import { ToastrService } from 'ngx-toastr';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
@Component({
  selector: 'app-liste-postes',
  imports: [
    ArianeNavComponent,
    MatDividerModule,
    DataTableOptimizedComponent,
    MatIconModule,
    MatButtonModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule
  ],
  templateUrl: './liste-postes.component.html',
  styleUrls: ['./liste-postes.component.scss']
})
export class ListePostesComponent implements OnInit, OnDestroy {
  @ViewChild('dataTablePoste') dataTablePoste!: DataTableOptimizedComponent;

  arianeLabel: string = 'Liste des postes';
  arianeIcon: string = 'list_alt';
  arianeList = [
    {
      label: 'Administration',
      url: '/pama/administration'
    },
    {
      label: 'Liste des postes',
      url: '/pama/administration/liste-postes'
    }
  ];
  demandesDisplayedColumns: string[] = [
    'Intitulé poste',
    'Numéro poste',
    'Catégorie poste',
    'Pole',
    'Direction',
    'Service',
    'Etat poste',
    'Poste budgété',
    'Occupation poste'
  ];

  demandesCellStyleCss: any = {
    Statut: { 'text-align': 'center' },
    'Date création': { 'text-align': 'center' }
  };

  filterSubject = new BehaviorSubject<FilterGenerique | null>({
    filterGenerique: null
  });
  length: number;
  untransformedData: any = [];
  dataTable: any[] = [];
  dataJSON: any[] = [];
  totalRecords_postes: number = 0;
  isExporting = false;
  filterGenerique = new FormControl();
  private readonly destroy$ = new Subject<void>();
  constructor(
    private readonly detectorRef: ChangeDetectorRef,
    private readonly referentielsService: ReferentielsService,
    private readonly excelService: ExcelService,
    private readonly snackBar: MatSnackBar,
    private readonly toastrDownloadService: ToastrDownloadService,
    private readonly toastrService: ToastrService
  ) {}
  ngOnInit() {
    this.filterGenerique.valueChanges.pipe(debounceTime(300), distinctUntilChanged(), takeUntil(this.destroy$)).subscribe((value) => {
      this.filterSubject.next({
        filterGenerique: value
      });
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.filterSubject.complete();
  }

  clearFilter(): void {
    this.filterGenerique.setValue('');
  }

  loadListPostes = (pageIndex: number, pageSize: number, filter?: FilterGenerique): Observable<PagedResultDTO<any>> => {
    return this.referentielsService.getListOfPostesWithParams(pageIndex, pageSize, filter).pipe(
      map((response) => {
        this.length = response.totalRecords;
        this.detectorRef.detectChanges();
        return {
          ...response,
          results: this.transformDataListePostes(response.results)
        };
      })
    );
  };

  transformDataListePostes(posteList: any[]): any {
    return posteList.map((poste) => {
      return {
        id: poste?.id,
        'Intitulé poste': poste?.libelle ?? '',
        'Numéro poste': poste?.numero ?? '',
        'Catégorie poste': poste?.categoriePoste?.code ?? '',
        Pole: poste?.direction?.pole?.libelle ?? '',
        Direction: poste?.direction?.libelle ?? '',
        Service: poste?.serviceFonctionnel?.libelle ?? '',
        'Etat poste': poste?.etat ?? '',
        'Poste budgété': poste?.budgete ? 'Oui' : 'Non',
        'Occupation poste': poste?.occupation ?? ''
      };
    });
  }

  convertExcel(data: any, name: string) {
    const search = '/';
    const replaceWith = '-';
    const date = new Date().toLocaleDateString('en-GB').split(search).join(replaceWith);
    let fileName = `${name}${date}`;
    this.excelService.exportToExcel(data, `${fileName}.xlsx`, 'Sheet1');
  }

  exportListePoste() {
    this.toastrService.clear();
    this.toastrDownloadService.showToast('Export en cours');

    this.referentielsService
      .getListOfPostesWithParams(0, this.length)
      .pipe(take(1))
      .subscribe({
        next: (result) => {
          const DataToexport = this.transformDataListePostes(result.results);
          const _data_export = DataToexport.map((line: any) => {
            const { id, ...lineWithoutId } = line;
            return lineWithoutId;
          });
          setTimeout(() => {
            this.toastrDownloadService.downloadSuccess();
          }, 3000);

          this.convertExcel(_data_export, 'Export_Liste_Postes_');

          this.snackBar.open('Export réussi !', 'Fermer', {
            duration: 4000,
            horizontalPosition: 'right',
            verticalPosition: 'top'
          });
        },
        error: (error) => {
          this.toastrDownloadService.removeToast();
          this.toastrService.clear();

          console.error("Erreur lors de l'export :", error);

          this.snackBar.open('Erreur lors de l’export', 'Fermer', {
            duration: 5000,
            horizontalPosition: 'right',
            verticalPosition: 'top'
          });
        }
      });
  }
}
